module.exports = __webpack_public_path__ + "static/media/dashboardIcon.8dbc99ee.svg";